import { render, staticRenderFns } from "./BodyRegister3.vue?vue&type=template&id=06601c8a"
import script from "./BodyRegister3.vue?vue&type=script&lang=ts"
export * from "./BodyRegister3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports